import React, { useEffect } from "react";
import LoanCalculator from "./QuotationLoanCalculator";

const InstalmentCalculation = ({ isEdit, formObj, handleFormObjChange }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <LoanCalculator title={"Loan Calculator"} isEdit={isEdit} formObj={formObj} handleFormObjChange={handleFormObjChange} />
    </>
  );
};

export default InstalmentCalculation;
